import { PageState } from 'models/PageState';
import { MediaQuery } from 'models/MediaQueryService';
import { combineReducers, ReducerOptionalMapObject } from 'store/createReducer';
import currentBreakpoint from 'store/responsive/reducer';
import appShell, { initialState as initAppShell } from 'store/appShell/reducer';
import footer, { initialState as footerInitialState } from 'components/Footer/reducer';
import currentPage, { headerReducer as headerCurrentPage } from 'components/Pagelayout/reducer';
import { HeaderState } from 'models/HeaderState';
import header, { initialState as initHeader } from 'components/Header/reducer';
import { search, initialState as initSearch } from 'components/Search/reducer';
import newsletter, { initialState as initNewsletter } from 'components/Newsletter/reducer';
import location, { initialState as initLocation } from 'store/history/reducer';
import cart, { initialState as initCart } from 'components/Cart/reducer';
import { initialState as initAlerts, alerts } from 'components/AlertNotification/reducer';
import error, { initialState as initError } from 'components/ErrorModal/reducer';
import basket from 'components/Basket/reducer';
import {
  initialHeaderCompareState as initCompare,
  headerCompare as compare
} from 'components/Compare/reducer';
import notification, { initialState as initNotification } from 'components/Notification/reducer';
import stores, { initialState as initStores } from 'components/StoreInfo/reducer';
import initCurrentPage from 'components/Pagelayout/initialPageState';
import { reducer as form } from 'redux-form';
import favourites, { initialState as initFavourites } from 'components/Favourites/reducer';

export const initialState: PageState = {
  appShell: initAppShell,
  location: initLocation,
  currentPage: initCurrentPage,
  newsletter: initNewsletter,
  footer: footerInitialState,
  currentBreakpoint: MediaQuery.Phone,
  compare: initCompare,
  error: initError,
  stores: initStores,
  header: initHeader,
  cart: initCart,
  basket: { showProductAdded: false },
  search: initSearch,
  notification: initNotification,
  favourites: initFavourites,
  alerts: initAlerts
};

export default combineReducers<PageState, ReducerOptionalMapObject>({
  appShell,
  location,
  footer,
  currentPage,
  currentBreakpoint,
  newsletter,
  compare,
  error,
  stores,
  header,
  cart,
  basket,
  search,
  notification,
  useNewSearch: false,
  form,
  favourites,
  alerts
});

export const initialHeaderState: HeaderState = {
  appShell: initAppShell,
  location: initLocation,
  header: initHeader,
  currentBreakpoint: MediaQuery.Phone,
  cart: initCart,
  stores: initStores,
  basket: { showProductAdded: false },
  search: initSearch,
  compare: initCompare,
  currentPage: initCurrentPage,
  notification: initNotification,
  favourites: initFavourites
};

export const combineHeaderReducers = combineReducers<HeaderState, ReducerOptionalMapObject>({
  appShell,
  location,
  header,
  currentBreakpoint,
  cart,
  stores,
  basket,
  search,
  compare,
  currentPage: headerCurrentPage,
  notification,
  favourites
});
